import Swal from "sweetalert2";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showClass: {
        backdrop: 'swal2-noanimation', // disable backdrop animation
        popup: '',                     // disable popup animation
    },
    didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    }
});

export default class ToastrPolyfill {
    static info(message, title = null, timeout = 3000) {
        this.showToast('info', message, title, timeout);
    }

    static success(message, title = null, timeout = 3000) {
        this.showToast('success', message, title, timeout);
    }

    static warning(message, title = null, timeout = 3000) {
        this.showToast('warning', message, title, timeout);
    }

    static error(message, title = null, timeout = 3000) {
        this.showToast('error', message, title, timeout);
    }

    static showToast(type, message, title = null, timeout = 3000) {
        if (title === null || title === undefined) {
            Toast.fire({
                icon: type,
                title: message,
                timer: timeout,
            });

            return;
        }

        Toast.fire({
            icon: type,
            title: title,
            text: message,
            timer: timeout,
        });
    }
}
